import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTopNavegation({
  selector,
}: {
  selector?: string;
}) {
  const { pathname, search } = useLocation();

  useEffect(() => {
    const el: Window | HTMLElement | null = selector
      ? document.querySelector<HTMLElement>(selector)
      : window;
    if (!el) return;

    el.scrollTo(0, 0);
  }, [pathname, search, selector]);

  return null;
}
